// Content for the Arcca × BRD × ISIC landing page (/arcca)

export const ASSETS = {
  arccaLogo: "/assets/arcca/arcca-logo.png",
  arccaLogoWhite: "/assets/arcca/arcca-logo-white.png",
  brdLogo: "https://customer-assets.emergentagent.com/job_isic-card-benefits/artifacts/qnijo0bb_BRD_logo.svg.webp",
  isicLogo: "https://customer-assets.emergentagent.com/job_isic-card-benefits/artifacts/bcfjcmyb_ISIC_logo_COLOUR_rgb.png",
  card: "https://customer-assets.emergentagent.com/job_bcf34023-7112-45b9-9c62-0f0e685c5e11/artifacts/e0fvi24n_BRD_ISIC_2021_front.jpg",
  campus: "/assets/arcca/campus.jpg",
  community: "/assets/arcca/community.jpg",
  room: "/assets/arcca/room.jpg",
  safety: "/assets/arcca/safety.jpg",
  metro: "/assets/arcca/metro.jpg",
  kitchen: "/assets/arcca/kitchen.jpg",
};

export const LINKS = {
  brdIsic: "/",
  discountsRo: "https://www.isic.ro/reduceri/local/?dmLimit=10&dmSortKey=views&dmSortOrder=desc&dmSeed=3100&dmDisplay=images",
  discountsIntl: "https://www.isic.org/discounts/",
};

export const HERO_CHIPS = [
  { icon: "ScanLine", label: "Acces în campus" },
  { icon: "CreditCard", label: "Card bancar BRD" },
  { icon: "Globe", label: "Beneficii ISIC în peste 130 de țări" },
];

export const CHANGE_CARDS = [
  {
    icon: "CreditCard",
    title: "Un singur card",
    text: "Același BRD-ISIC poate fi folosit pentru acces, plăți și beneficiile tale de student.",
  },
  {
    icon: "ScanLine",
    title: "Acces rapid",
    text: "Apropie cardul de cititorul compatibil și intri simplu prin turnicheții adaptați pentru noul sistem.",
  },
  {
    icon: "IdCard",
    title: "Fără card suplimentar",
    text: "Pentru noua soluție, nu ai nevoie de încă o legitimație separată. BRD-ISIC devine cardul pe care îl poți folosi și la acces.",
  },
];

export const THREE_ROLES = [
  {
    icon: "DoorOpen",
    tag: "La Arcca",
    text: "Îl poți folosi pentru accesul prin turnicheții compatibili din campus.",
  },
  {
    icon: "Wallet",
    tag: "În fiecare zi",
    text: "Îl folosești și pentru plățile de zi cu zi.",
  },
  {
    icon: "Globe",
    tag: "Oriunde mergi",
    text: "Ai legitimația internațională ISIC inclusă și acces la beneficii în peste 130 de țări.",
  },
];

export const LIFE_BLOCKS = [
  {
    icon: "DoorOpen",
    tag: "Pentru acces",
    text: "Cardul BRD-ISIC poate fi folosit la turnicheții compatibili din campus.",
    image: ASSETS.safety,
  },
  {
    icon: "Wallet",
    tag: "Pentru ziua de zi cu zi",
    text: "Îl poți folosi ca card bancar BRD pentru plățile tale obișnuite.",
    image: ASSETS.kitchen,
  },
  {
    icon: "Sparkles",
    tag: "Pentru avantajele de student",
    text: "Ai legitimația internațională ISIC inclusă și acces la beneficii în România și în străinătate.",
    image: ASSETS.community,
  },
];

export const ROLLOUT_ENTRANCES = [
  {
    title: "Intrarea principală",
    text: "La intrarea principală sunt 5 turnicheți. În prima etapă, 2 dintre ei vor putea fi folosiți doar cu BRD-ISIC.",
    total: 5,
    active: 2,
  },
  {
    title: "A doua intrare",
    text: "La a doua intrare sunt 2 turnicheți. În prima etapă, 1 turnichet va fi adaptat pentru BRD-ISIC, iar celălalt va rămâne pe sistemul actual.",
    total: 2,
    active: 1,
  },
];

export const ROLLOUT_EXTEND = {
  title: "Următorul pas",
  text: "Pe măsură ce implementarea avansează, Arcca va comunica studenților când vor putea folosi BRD-ISIC și la ceilalți turnicheți.",
};

export const STEPS = [
  {
    title: "Aplici pentru BRD-ISIC",
    text: "Alegi cardul dedicat elevilor și studenților și urmezi procesul de aplicare BRD.",
  },
  {
    title: "Primești cardul",
    text: "După emitere, BRD-ISIC este automat activ în sistemul de control acces Arcca.",
  },
  {
    title: "Îl folosești zi de zi",
    text: "Intri în campus, plătești cu cardul și folosești beneficiile ISIC în România și în străinătate.",
  },
];

export const ZONES = [
  {
    icon: "DoorOpen",
    tag: "La Arcca",
    text: "Folosești cardul pentru accesul prin turnicheții compatibili.",
  },
  {
    icon: "Coffee",
    tag: "În oraș",
    text: "Plătești cu cardul și descoperi beneficii ISIC la branduri relevante pentru studenți.",
  },
  {
    icon: "Plane",
    tag: "În călătorii",
    text: "Ai o legitimație internațională de student recunoscută global și acces la beneficii în peste 130 de țări.",
  },
];

export const BENEFIT_INDICATORS = [
  { value: "130+", label: "de țări" },
  { value: "Mii", label: "de beneficii și reduceri" },
  { value: "8.000 lei", label: "economii posibile pe an" },
];

export const NATIONAL_BENEFITS = [
  { name: "Penny", offer: "10% reducere", logo: "/assets/ro/logo-penny.webp", link: "https://www.isic.ro/reduceri/ro/penny/9679" },
  { name: "Starbucks", offer: "20% reducere la băuturi și gustări", logo: "/assets/ro/logo-starbucks.png", link: "https://www.isic.ro/reduceri/ro/starbucks/10799" },
  { name: "Burger King", offer: "15% reducere", logo: "/assets/ro/logo-burger-king.png", link: "https://www.isic.ro/reduceri/ro/burger-king/6921" },
  { name: "IKEA", offer: "10% reducere la cardurile cadou", logo: "/assets/ro/logo-ikea.png", link: "https://www.isic.ro/reduceri/ro/ikea/6994" },
  { name: "World Class", offer: "Până la 40€ reducere la abonamente", logo: "/assets/ro/logo-worldclass.png", link: "https://www.isic.ro/reduceri/ro/world-class/3579" },
  { name: "Spotify", offer: "Ofertă specială pentru studenți", logo: "/assets/ro/logo-spotify.webp", link: "https://www.isic.ro/reduceri/ro/spotify/9056" },
  { name: "Sephora", offer: "20% reducere la Sephora Collection", logo: "/assets/ro/logo-sephora.webp", link: "https://www.isic.ro/reduceri/ro/sephora/10161" },
  { name: "Christian Tour", offer: "Travel Prime gratuit, în loc de 79€ pe an", logo: "/assets/ro/logo-christian-tour.png", link: "https://www.isic.ro/reduceri/ro/christian-tour/10378" },
  { name: "Carrefour", offer: "7% reducere", logo: "/assets/ro/logo-carrefour.webp", link: "https://www.isic.ro/reduceri/ro/carrefour/7921" },
];

export const GLOBAL_BENEFITS = [
  { alt: "Berlin — The Wall Museum — 6 euro reducere", image: "/assets/intl/intl-wall.png" },
  { alt: "Paris — Disneyland — până la 39 euro reducere", image: "/assets/intl/intl-disneyland.png" },
  { alt: "Roma — Muzeele Vaticane — 9 euro reducere", image: "/assets/intl/intl-vatican.png" },
  { alt: "Madrid — Muzeul Prado — 14 euro reducere", image: "/assets/intl/intl-prado.png" },
  { alt: "Paris — Arcul de Triumf — 3 euro reducere", image: "/assets/intl/intl-paris.png" },
];

export const WHATIS_COLUMNS = [
  {
    icon: "CreditCard",
    accent: "brd",
    title: "Componenta BRD",
    text: "Card de debit pentru elevi și studenți, pentru plățile și operațiunile bancare de zi cu zi.",
  },
  {
    icon: "Globe",
    accent: "isic",
    title: "Componenta ISIC",
    text: "Legitimație internațională de student, recunoscută la nivel global, cu acces la mii de beneficii și reduceri în România și în peste 130 de țări.",
  },
  {
    icon: "ScanLine",
    accent: "arcca",
    title: "Componenta Arcca",
    text: "Acces în campus prin sistemul de control acces compatibil, fără emiterea unei legitimații suplimentare pentru această soluție.",
  },
];

export const PRIVACY_POINTS = [
  "Arcca nu vede soldul cardului.",
  "Arcca nu vede tranzacțiile bancare.",
  "Accesul în campus este separat de utilizarea bancară a cardului.",
  "Cardul este folosit la turnicheți doar pentru identificarea în sistemul de acces.",
];
